import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import ToggleInLibraryDialog from "../components/MyLibrary/ToggleInLibraryDialog";

import useLogin from "./useLogin";
import { useModalContext } from "../contexts/modal";
import { selectorSetting } from "../store/settings/selectors";
import { selectorSystemIsLogin } from "../store/system/selectors";
import { TOGGLE_IN_LIBRARY_BEHAVIOURS } from "../constants";
import { SETTING } from "../utils/settings/constants";
import { _sharedActionsSettings } from "../store/settings/actions";
import { _sharedActionsLibrary } from "../store/library/actions";

const useToggleInLibrary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showModal } = useModalContext();
  const { showLoginConfirm } = useLogin();
  const isLogin = useSelector(selectorSystemIsLogin);
  const toggleInLibraryBehaviour = useSelector(
    selectorSetting(SETTING.toggleInLibraryBehaviour.id)
  );

  const _toggle = (inLibrary, bookIds, onSuccess) => {
    dispatch(_sharedActionsLibrary.toggleBookInMLById(bookIds));

    if (onSuccess) {
      onSuccess();
    }
  };

  const showToggleInLibraryDialog = (inLibrary, bookIds, onSuccess) => {
    const isRemoveCoupleBooks = Array.isArray(bookIds) && bookIds.length;
    const message = isRemoveCoupleBooks ? t("removeCoupleFromML", { count: bookIds.length, }) : t(inLibrary ? "removeFromML?" : "addToML?");
    const component = (
      <ToggleInLibraryDialog
        isRemoveCoupleBooks={isRemoveCoupleBooks}
        message={message}
        onConfirm={(doNotAskAgain) => {
          if (doNotAskAgain) {
            dispatch(
              _sharedActionsSettings.updateSettings(
                SETTING.toggleInLibraryBehaviour.id,
                TOGGLE_IN_LIBRARY_BEHAVIOURS.DO_NOT_ASK,
              ),
            );
          }

          _toggle(inLibrary, bookIds, onSuccess);
        }}
      />
    );
    showModal(component, {
      title: "confirmation",
    });
  };

  const toggleInLibrary = (inLibrary, bookIds, onToggleSuccess) => {
    const isRemoveCoupleBooks = Array.isArray(bookIds) && bookIds.length;

    if (isLogin) {
      if (toggleInLibraryBehaviour === TOGGLE_IN_LIBRARY_BEHAVIOURS.ASK || isRemoveCoupleBooks) {
        showToggleInLibraryDialog(inLibrary, bookIds, onToggleSuccess);
      } else {
        _toggle(inLibrary, bookIds, onToggleSuccess);
      }
    } else {
      return new Promise((resolve) => {
        showLoginConfirm(resolve, () => resolve({ authWindowWasOpened: true }));
      });
    }
  };

  return toggleInLibrary;
};
export default useToggleInLibrary;
